import { CSSProperties, useContext, useEffect, useState } from "react";
import AuthenticationHOC, { AuthHOCProps } from "../AuthenticationHOC/AuthenticationHOC";
import { Context, IContext } from "../../context/ContextApp";

interface Feed {
  branch_id: number;
  content: string;
  created_at: string;
  id: number;
  image_content_type?: string;
  image_file_name?: string;
  image_file_size?: string;
  image_updated_at?: string;
  title: string;
  updated_at: string;
}

interface Response {
  feeds: Feed[];
}

const NotificationBar = (props: AuthHOCProps) => {
  const [feeds, setFeeds] = useState<Feed[]>([]);
  const { generateAuthHeader } = props;
  const { appBranch }: IContext = useContext(Context);

  useEffect(() => {
    const fetchFeed = async () => {
      const url = `${process.env.REACT_APP_HALFBACK_ROOT_API}/feeds/${appBranch}`;

      try {
        const res = await fetch(url, generateAuthHeader());
        const data: Response = await res.json();
        setFeeds(data.feeds);
      } catch (error) {}
    };

    fetchFeed();
  }, [generateAuthHeader, appBranch]);

  const createMarkup = (html: any) => ({ __html: html });

  const barStyle: CSSProperties = {};
  if (process.env.REACT_APP_NOTIFICATION_BAR_BG) {
    barStyle.backgroundColor = process.env.REACT_APP_NOTIFICATION_BAR_BG;
  }
  if (process.env.REACT_APP_NOTIFICATION_BAR_COLOR) {
    barStyle.color = process.env.REACT_APP_NOTIFICATION_BAR_COLOR;
  }

  return (
    <>
      {feeds.length > 0 && (
        <div className="notification-bar" style={barStyle}>
          <span className="notification-bar__title">{feeds[0].title} </span>
          <span dangerouslySetInnerHTML={createMarkup(feeds[0].content)} />
        </div>
      )}
    </>
  );
};

export default AuthenticationHOC(NotificationBar);
